import { render } from "./Cart.vue?vue&type=template&id=2c4b478c"
import script from "./Cart.vue?vue&type=script&lang=js"
export * from "./Cart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Goya/components/Cart/Cart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c4b478c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c4b478c', __exports__)) {
    api.reload('2c4b478c', __exports__)
  }
  
  module.hot.accept("./Cart.vue?vue&type=template&id=2c4b478c", () => {
    api.rerender('2c4b478c', render)
  })

}


export default __exports__